/* Veroni scroll reveal — progressive enhancement only.
 *
 * Elements are made revealable BY this script (the .v-reveal class that
 * hides content is only ever added here), so with JS disabled or failed
 * nothing is ever hidden. Respects prefers-reduced-motion. The IO root is
 * the viewport, which works even though the real scroll container is
 * .page-wrapper (Horizon app-shell) — viewport intersection still changes
 * as the inner container scrolls.
 */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SELECTORS = [
    '.v-card',
    '.v-category-tile',
    '.v-atelier__copy',
    '.v-about-facts .v-fact',
    '.v-prose > *',
  ];

  const els = document.querySelectorAll(SELECTORS.join(','));
  if (!els.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('v-reveal--in');
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -7% 0px', threshold: 0.05 }
  );

  for (const el of els) {
    // Stagger by position among siblings so grid rows land as a wave.
    const siblingIndex = Array.prototype.indexOf.call(el.parentElement.children, el);
    el.style.setProperty('--v-reveal-delay', `${Math.min(siblingIndex % 8, 5) * 55}ms`);
    el.classList.add('v-reveal');
    io.observe(el);
  }
})();
